/*
 * Zahnheld checkbox motion
 * ---------------------------------------------------------------------------
 * Plays the check and release motion of the brand checkbox (zahnheld.css,
 * `.checkbox`) when the visitor toggles one, and only then.
 *
 * The obvious CSS-only trigger, an animation on `:checked`, also fires for every
 * box that is already checked when it enters the DOM: on page load, and in the
 * filter drawer for every active filter each time the facets re-render. And
 * unchecking cannot be done in CSS at all, because a "not checked" selector
 * matches on page load too. So the change event sets a class the keyframes hang
 * on, and the class is dropped again when they finish.
 *
 * Programmatic `input.checked = ...` fires no change event and stays silent,
 * which is what a restored or synced state should do.
 */
(function () {
  'use strict';

  var CHECKING = 'is-checking';
  var RELEASING = 'is-releasing';

  function restart(element, className) {
    element.classList.remove(CHECKING, RELEASING);
    // Reading layout commits the removal, so the same class starts the keyframes
    // again on a quick double toggle.
    void element.offsetWidth;
    element.classList.add(className);
  }

  // Capture phase: some theme components stop propagation of change events.
  document.addEventListener('change', function (event) {
    var input = event.composedPath ? event.composedPath()[0] : event.target;
    if (!(input instanceof HTMLInputElement) || !input.classList.contains('checkbox')) return;
    restart(input, input.checked ? CHECKING : RELEASING);
  }, true);

  document.addEventListener('animationend', function (event) {
    if (event.animationName === 'zh-checkbox-jelly') event.target.classList.remove(CHECKING);
    if (event.animationName === 'zh-checkbox-release') event.target.classList.remove(RELEASING);
  }, true);
})();
